import VurbalizeEvents from "../../common/types/dto/chat/vurbalize-events";

const getMessageByVurablizeEvent = (event: VurbalizeEvents, payload = '') => {
  switch (event) {
    case VurbalizeEvents.INPUT_PROVIDED:
      return `user typed: ${payload?.trim()}`;
    case VurbalizeEvents.NEW_PAGE_NAVIGATION:
      return "User navigated to new page";
    case VurbalizeEvents.USERS_FIRST_MESSAGE:
      return "User send first message";
    case VurbalizeEvents.TALK_TO_SALES_BUTTON_CLICK:
      return `${payload} Request`;
    case VurbalizeEvents.CALLBACK_REQUEST_EVENT:
      return `${payload} - Callback Request`;
    case VurbalizeEvents.TALK_TO_EXPERT_CLICKED:
      return "User Clicked Talk to Expert Suggestion";
    case VurbalizeEvents.SUGGESTION_TEXT_CLICKED:
      return "User Clicked Suggestion text";
    case VurbalizeEvents.IFRAME_BUTTON_CLICK_EVENT:
      return `User clicked button inside iframe`;
    case VurbalizeEvents.DELTA_LOGS_MESSAGE_API:
      return `Send message response time`;
    case VurbalizeEvents.MEETING_CONNECT_REQUEST:
      return 'Chat Connect Request';
    case VurbalizeEvents.REDIRECT_SUGGESTED:
      return 'Redirect url was suggested';
    case VurbalizeEvents.SOCKET_ERROR:
      return 'received socket error';
    case VurbalizeEvents.SOCKET_RESPONSE_TIMEOUT:
      return 'Socket re-connect error';
    case VurbalizeEvents.FEEDBACK_FORM:
      return `Request to open feedback form`;
    case VurbalizeEvents.FEEDBACK_SUBMITTED:
      return 'user submitted feedback';
    case VurbalizeEvents.WIDGET_CHAT_ICON_CLICK:
      return `User ${payload || 'clicked'} widget`;
    case VurbalizeEvents.NUDGE_MESSAGE_TEXT_CLICKED:
      return 'User Clicked nudge';
    case VurbalizeEvents.REDIRECT_CLICKED:
      return `User clicked on hyperlink: ${payload}`;
    case VurbalizeEvents.USER_FEEDBACK:
      return `User feedback ${payload}`;
    case VurbalizeEvents.HUBSPOT_CALENDAR_OPEN:
      return "Hubspot Calendar opened";
    case VurbalizeEvents.HUBSPOT_MEETING_SCHEDULED:
      return "hubspot meeting scheduled";
    case VurbalizeEvents.HUBSPOT_FORM_SUBMITTED:
      return "hubspot form submitted";
    case VurbalizeEvents.CALENDLY_CLOSE_EVENT:
      return 'User clicked close button';
    case VurbalizeEvents.MEETING_REQUEST_EVENT:
      return 'Chat - Meeting Request';
    case VurbalizeEvents.CALLBACK_SUBMIT_EVENT:
      return 'Chat - Callback Submit';
    case VurbalizeEvents.CALLBACK_UI_EVENT:
      return 'User clicked close button';
    case VurbalizeEvents.CALLBACK_REQUEST_EVENT:
      return 'Chat - Callback Request';
    case VurbalizeEvents.HERO_PAGE_VISITED:
      return 'user visit hero page';
    case VurbalizeEvents.CALENDLY_EVENT_FRONTEND:
      return 'Chat - Meeting Set';
    case VurbalizeEvents.MARKETO_EVENT:
      return 'Marketo lead created';
    case VurbalizeEvents.USER_FEEDBACK_CLOSE:
      return 'User closes feedback form';
    case VurbalizeEvents.HUBSPOT_CALENDAR_CLOSE:
      return 'User closed hubspot calendar';
    case VurbalizeEvents.NUDGE_CLOSED:
      return 'User closed nudge';
    case VurbalizeEvents.WIDGET_CHAT_HEADER_CLOSE:
      return 'User closed widget by clicking close button on header';
    case VurbalizeEvents.USER_CLICK:
      return 'User clicked';
    case VurbalizeEvents.LIVE_AGENT_PINGED_USER:
      return 'User in browsing state got message from live agent';
    case VurbalizeEvents.USER_IS_ACTIVE:
      return 'User is active';
    case VurbalizeEvents.CUSTOM_CALENDAR_OPENED:
      return 'User opened custom calendar';
    case VurbalizeEvents.CUSTOM_CALENDAR_CLOSED:
      return 'User closed custom calendar';
    case VurbalizeEvents.CUSTOM_CALENDAR_EVENT_SCHEDULED:
      return 'User scheduled an event in custom calendar';
    case VurbalizeEvents.CUSTOM_CALENDAR_UI_EVENT:
      return 'User interacted with custom calendar UI';

    case VurbalizeEvents.USER_SEND_MESSAGE:
    case VurbalizeEvents.CALENDLY_UI_EVENT:
    default:
      return payload || '';
  }
};

export default getMessageByVurablizeEvent;
